var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{ref:"aside",staticClass:"hide-btn",class:_vm.dynamicClass,attrs:{"type":"primary"},on:{"click":(e) => _vm.$emit('toggle', e)}},[_c('el-icon',{attrs:{"size":"32","name":"i-hide-panel-o--24"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }